var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "in-box-wrapper" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _vm._l(_vm.tabs, function (item, index) {
                return [
                  _vm.authPromise(item.auth)
                    ? _c("el-tab-pane", {
                        key: index,
                        attrs: { label: item.label, name: item.name },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c("p", { staticStyle: { color: "#999" } }, [
            _c("i", { staticClass: "el-icon-warning" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("after-sales::after-sales-set::setting_default_tips")
                ) +
                " "
            ),
            _c(
              "span",
              { staticStyle: { color: "#ff4d00", "font-weight": "bold" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "after-sales::after-sales-set::setting_default_tips_red"
                    )
                  )
                ),
              ]
            ),
          ]),
          _c("sale-" + _vm.activeTab, {
            tag: "component",
            staticStyle: { "margin-top": "10px" },
            attrs: { params: _vm.params },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }